import React, { PropTypes } from 'react';
import partial from 'lodash/partial';

const HorizontalSelector = ({ options, value, onSelect }) => (
  <ul className="horizontal-selector">
    { options.map((opt, i) => (
    <li key={i} className={value === opt.value? "selected" : ""} onClick={partial(onSelect, opt.value)}>
      { opt.label }
    </li>
    )) }
  </ul>
);

HorizontalSelector.propTypes = {
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default HorizontalSelector;



// WEBPACK FOOTER //
// ./common/components/horizontal_selector.jsx